import HttpClient from '@/services/http-client'

class MeterPieceService extends HttpClient {
  async show(id) {
    return this.rest.get('/v1/meter-pieces/' + id)
  }

  async list(page = 1, limit = 1000, text = null) {
    return this.rest.get('/v1/meter-pieces', {
      params: {
        page,
        limit,
        q: text
      }
    })
  }

  async create(payload) {
    return this.rest.post('/v1/meter-pieces', payload)
  }

  async update(payload) {
    return this.rest.patch('/v1/meter-pieces/' + payload.id, payload)
  }

  async delete(id) {
    return this.rest.delete('/v1/meter-pieces/' + id)
  }
}

export default () => new MeterPieceService()
